var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.56,
    x2: 39.2,
    y1: 21.96,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 27.5,
    x2: 36.5,
    y1: 50.21,
    y2: 65.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 44.21,
    y2: 59.79,
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M46.5 31.5h-.32a10.49 10.49 0 0 0-19.11-8 7 7 0 0 0-10.57 6 7.21 7.21 0 0 0 .1 1.14A7.5 7.5 0 0 0 18 45.5a4.19 4.19 0 0 0 .5 0h28a7 7 0 0 0 0-14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M17 58h30"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "5s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-4 0; 4 0; -4 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#c)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M17 52h30"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-4s",
    dur: "5s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-4 0; 4 0; -4 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.1f6622bb84bb395bf9fab8cf46f63076.svg";
export { ForwardRef as ReactComponent };